import React from 'react'
import ExpenseEntry from './ExpenseEntry'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
function DragExpenses({ expenses, truncate,droppableID }) {
    
    return (
        <>
            <Droppable droppableId={droppableID}>
                {(provided) => (
                        <div className='unlinked-expenses-container'{...provided.droppableProps} ref={provided.innerRef}>
                            {expenses.map((expense, index) =>
                                <>
                                    <ExpenseEntry index={index} expense={expense} truncate={truncate} />
                                </>)}
                            {provided.placeholder}
                        </div>
                    )}
            </Droppable>

        </>
    )
}

export default DragExpenses